//MIXIN ADDED FOR ONE TRUST COOKIE CONSENT CHECK
import { OTCookieGroups } from './enums';
import { EventBus } from './event';
// Change the variable name
window.ConsentEventEmitters = window.ConsentEventEmitters || [];

export default {
  methods: {
    // Helper method to check if all cookie categories are active
    areAllCookieCategoriesActive() {
      return Object.values(OTCookieGroups).every((group) =>
        window.OnetrustActiveGroups.includes(group),
      );
    },
  },
  mounted() {
    const { isConsentEnabled } = this; // Renamed for clarity and consistency

    // If consent is not enabled,Emit the event immediately
    if (!isConsentEnabled) {
      EventBus.$emit(this.otReviewEmitter, true);
      return;
    }

    // Check for OneTrust availability periodically
    const _self = this;
    const cookieConsentCheckInterval = setInterval(() => {
      if (!window.OneTrust) return; // Wait for OneTrust to be available

      let isCookieActivate =
        typeof _self.areAllCookieCategoriesActive === 'function'
          ? _self.areAllCookieCategoriesActive()
          : _self.methods.areAllCookieCategoriesActive();
      if (isCookieActivate) {
        EventBus.$emit(_self.otReviewEmitter, true);
      } else {
        window.ConsentEventEmitters.push(this.otReviewEmitter);
        window.OneTrust.OnConsentChanged(() => {
          let isConsentCookieActivate =
            typeof _self.areAllCookieCategoriesActive === 'function'
              ? _self.areAllCookieCategoriesActive()
              : _self.methods.areAllCookieCategoriesActive();
          // Emit an event indicating whether all necessary cookie groups are active
          // Loop through emitters and trigger events/emitters dynamically
          window.ConsentEventEmitters.forEach((emitterName) => {
            EventBus.$emit(emitterName, isConsentCookieActivate);
          });
        });
      }
      clearInterval(cookieConsentCheckInterval); // Clear the interval once OneTrust is available
    }, 500);
  },
};
